import styled from 'styled-components'

const StyledLinkPagePreviewDialog = styled.div``

export default StyledLinkPagePreviewDialog
